<template>
  <div>

    <span class="text_60">你和面试官的面试还愉快吗？</span>

    <div class="list_1 flex-row">

      <div class="image-wrapper_3 flex-col" v-for="(item, index) in loopData0" :key="index"
        @mouseover="item.lanhuimage0 = item.activeImg"
        @mouseleave="item.lanhuimage0 = index == clickTarget ? item.activeImg : item.inactiveImg"
        @click="handleClick(index)">
        <el-tooltip effect="dark" :content="item.tooltip" placement="top" open-delay="1000">
          <img class="label_1" referrerpolicy="no-referrer" :src="item.lanhuimage0" />
        </el-tooltip>
      </div>
    </div>
    <span class="text_61">如果你愿意的话，欢迎说说你的想法，面试官会努力做更好！</span>
    <textarea class="group_14 flex-col" placeholder="欢迎说说你的想法" v-model="commentText"></textarea>
    <div class="group_15 flex-row">
      <el-button class="text-wrapper_29 flex-col" @click="cancel">以后再说</el-button>
      <el-button class="text-wrapper_30 flex-col" :disabled="commentText == ''" @click="submit">确认</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      commentText: '',
      clickTarget: -1,
      loopData0: [
        // {
        //   tooltip: '很不理想',
        //   lanhuimage0: 'https://lanhu-oss.lanhuapp.com/SketchPng404722dcb5c6f68b3a048cf565f58c70dbdbd84fc0c8b418d822c7af0df540e2',
        //   inactiveImg: 'https://lanhu-oss.lanhuapp.com/SketchPng404722dcb5c6f68b3a048cf565f58c70dbdbd84fc0c8b418d822c7af0df540e2',
        //   activeImg: 'https://lanhu-oss.lanhuapp.com/SketchPng168a44b8bd0382ac65439d7795302053625494de94ad11a4bafd77e6ee178b1f'
        // },
        // {
        //   tooltip: '还行',
        //   lanhuimage0: 'https://lanhu-oss.lanhuapp.com/SketchPnga8a7b0bc08c89ef92e1b5444ce5cb430601733fe5b518abcbaf5e5870091477d',
        //   inactiveImg: 'https://lanhu-oss.lanhuapp.com/SketchPnga8a7b0bc08c89ef92e1b5444ce5cb430601733fe5b518abcbaf5e5870091477d',
        //   activeImg: 'https://lanhu-oss.lanhuapp.com/SketchPng0adc9f3e67a6ae5d85b3f7eb32b4bd9dac4b508024f9990ebfed1cdb53a2fb4d'
        // },
        // {
        //   tooltip: '期待',
        //   //lanhuimage0: 'https://lanhu-oss.lanhuapp.com/SketchPng26077518882bb11c1647098df223d745936e1e22258277399b4fd36da2119aa5',
        //   lanhuimage0: require('./assets/img/敬请期待_gray.png'),
        //   inactiveImg: require('./assets/img/敬请期待_gray.png'),
        //   activeImg: require('./assets/img/敬请期待.png')
        // },
        // {
        //   tooltip: '开心',
        //   //lanhuimage0: 'https://lanhu-oss.lanhuapp.com/SketchPng596701de0fbc7222895bd1e94ac172f7000bfd486c165b40d3516bbbba7dc7e6'
        //   lanhuimage0: require('./assets/img/开心_gray.png'),
        //   inactiveImg: require('./assets/img/开心_gray.png'),
        //   activeImg: require('./assets/img/开心.png')
        // },
        {
          tooltip: '爱了爱了',
          //lanhuimage0: 'https://lanhu-oss.lanhuapp.com/SketchPng615f3616ef4d5ebdb20240f7e792ca2e116b17a875b7c89b482c675971fd44c1'
          lanhuimage0: require('./assets/img/Emoji-in-love_gray.png'),
          inactiveImg: require('./assets/img/Emoji-in-love_gray.png'),
          activeImg: require('./assets/img/Emoji-in-love.png')
        }
      ],
    };
  },
  methods: {
    cancel() { this.$emit('close') },
    submit() {
      //TODO: send comment data
      this.cancel()
    },
    handleClick(index) {
      this.clickTarget = index
      for (const key in this.loopData0) {
        if (key == index) continue
        const item = this.loopData0[key]
        item.lanhuimage0 = item.inactiveImg
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
